import PropTypes from "prop-types";
import { z } from "zod";

import {
  BaseForm,
  FormInput,
  FormMultiSelect,
  FormTextarea,
} from "components/BaseForm";
import { useApiKeyMutations } from "hooks/useApiKeysTable";

const SCOPE_OPTIONS = [
  { key: "db:query", text: "db:query", value: "db:query" },
  { key: "db:schema", text: "db:schema", value: "db:schema" },
  { key: "db:*", text: "db:* (all db scopes)", value: "db:*" },
];

const schema = z.object({
  service_name: z.string().min(1, "Service Name is required"),
  scopes: z.array(z.string()).min(1, "Select at least one scope"),
  description: z.string(),
});

const defaultValues = { service_name: "", scopes: [], description: "" };

const ApiKeyForm = ({ onSuccess, onCancel }) => {
  const { create } = useApiKeyMutations();

  const handleSubmit = async ({ service_name, scopes, description }) => {
    const data = { service_name, scopes };
    if (description) {
      data.description = description;
    }
    const response = await create.mutateAsync(data);
    onSuccess(response);
  };

  return (
    <BaseForm
      schema={schema}
      defaultValues={defaultValues}
      submitButtonText="Create"
      submittingButtonText="Creating"
      onSubmit={handleSubmit}
      onCancel={onCancel}
    >
      <FormInput
        name="service_name"
        label="Service Name"
        placeholder="e.g. aegis"
        required
        autoFocus
      />
      <FormMultiSelect
        name="scopes"
        label="Scopes"
        placeholder="Select scopes"
        options={SCOPE_OPTIONS}
        required
      />
      <FormTextarea
        name="description"
        label="Description"
        placeholder="Optional description of what this key is used for"
      />
    </BaseForm>
  );
};

ApiKeyForm.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ApiKeyForm;
